import React from 'react';
import { Avatar, Button, Dropdown } from 'antd';
import { LogoutOutlined, UserOutlined, MoonOutlined, SunOutlined } from '@ant-design/icons';
import AIChatWidget from '../components/AIChat/AIChatWidget';
import useAuthStore from '../store/authStore';
import useThemeStore from '../store/themeStore';

// Mobile-only experience: the AI chat IS the entire app.
// All CRM operations go through the agent (create lead, log meeting, query
// pipeline, etc.) — there's no separate UI on mobile.
const MobileChatPage = () => {
  const { user, logout } = useAuthStore();
  const { theme, toggleTheme } = useThemeStore();
  const isDark = theme === 'dark';

  const handleLogout = async () => {
    await logout();
    window.location.href = '/auth/login';
  };

  const userMenuItems = [
    {
      key: 'who',
      disabled: true,
      label: (
        <div style={{ minWidth: 180 }}>
          <div style={{ fontWeight: 600, color: '#0f172a' }}>{user?.fullName || 'User'}</div>
          <div style={{ fontSize: 11, color: '#64748b' }}>{user?.email}</div>
        </div>
      ),
    },
    { type: 'divider' },
    {
      key: 'theme',
      icon: isDark ? <SunOutlined /> : <MoonOutlined />,
      label: isDark ? 'Light theme' : 'Dark theme',
      onClick: toggleTheme,
    },
    { type: 'divider' },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      danger: true,
      label: 'Sign out',
      onClick: handleLogout,
    },
  ];

  return (
    <div
      style={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        background: '#0f172a',
        overflow: 'hidden',
      }}
    >
      {/* Slim mobile header overlay (sits on top of the chat shell's own
          header). The chat shell already has its own avatar + status row;
          this one adds the user menu so people can sign out / toggle theme. */}
      <div
        style={{
          position: 'fixed',
          top: 8,
          right: 8,
          zIndex: 50,
        }}
      >
        <Dropdown
          menu={{ items: userMenuItems }}
          trigger={['click']}
          placement="bottomRight"
        >
          <Button
            type="text"
            style={{
              padding: 4,
              height: 'auto',
              borderRadius: 999,
              background: 'rgba(255,255,255,0.08)',
              border: '1px solid rgba(255,255,255,0.12)',
            }}
          >
            <Avatar
              size={28}
              icon={<UserOutlined />}
              style={{
                background: 'linear-gradient(135deg, #1e40af, #3b82f6)',
                color: '#fff',
              }}
            />
          </Button>
        </Dropdown>
      </div>

      <div style={{ flex: 1, minHeight: 0 }}>
        <AIChatWidget inline />
      </div>
    </div>
  );
};

export default MobileChatPage;
